import { Outlet } from 'react-router-dom'
import UserBar from './UserBar'
import { useAssignmentBadges } from '../../hooks/useAssignmentBadges'

export default function AppShell() {
  useAssignmentBadges()
  return (
    <div className="app-shell" data-testid="app-shell">
      <UserBar />
      <main id="main" data-testid="main-content">
        <Outlet />
      </main>
    </div>
  )
}
